import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

export default function Button({
  children,
  icon,
  color,
  variant,
  size,
  className,
  block,
  type = "button",
  ...buttonProps
}) {
  let colorClass = null;
  switch (color) {
    default:
    case "primary":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-primary hover:bg-primary/90 active:bg-primary/90 text-white";
          break;
        case "outline":
          colorClass =
            "border-primary text-primary hover:bg-primary hover:text-white active:bg-primary active:text-white";
          break;
      }
      break;
    case "secondary":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-secondary hover:bg-secondary/90 active:bg-secondary/90 text-white";
          break;
        case "outline":
          colorClass =
            "border-secondary text-secondary hover:bg-secondarty hover:text-white active:bg-secondary active:text-white";
          break;
      }
      break;
    case "tertiary":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-tertiary hover:bg-tertiary/90 active:bg-tertiary/90 text-white";
          break;
        case "outline":
          colorClass =
            "border-tertiary text-tertiary hover:bg-tertiary hover:text-white active:bg-tertiary active:text-white";
          break;
      }
      break;
    case "success":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-success text-white hover:bg-success/90 active:bg-success/90";
          break;
        case "outline":
          colorClass =
            "border-success text-success hover:bg-success hover:text-white active:bg-success active:text-white";
          break;
      }

      break;
    case "info":
      switch (variant) {
        default:
        case "default":
          colorClass = "bg-info text-white hover:bg-info/90 active:bg-info/90";
          break;
        case "outline":
          colorClass =
            "border-info text-info hover:bg-info hover:text-white active:bg-info active:text-white";
          break;
      }
      break;
    case "warning":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-warning hover:bg-warning/90 active:bg-warning/90 text-white";
          break;
        case "outline":
          colorClass =
            "border-warning text-warning hover:bg-warning hover:text-white active:bg-warning active:text-white";
          break;
      }
      break;
    case "danger":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-danger hover:bg-danger/90 active:bg-danger/90 text-white";
          break;
        case "outline":
          colorClass =
            "border-danger text-danger hover:bg-danger hover:text-white active:bg-danger active:text-white";
          break;
      }
      break;
    case "dark":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-dark hover:bg-dark/90 active:bg-dark/90 text-white border border-dark/50";
          break;
        case "outline":
          colorClass =
            "border-dark hover:bg-dark hover:text-white active:bg-dark";
          break;
      }
      break;
    case "link":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-transparent text-gray-500 hover:text-primary underline";
          break;
      }
      break;
    case "light":
      switch (variant) {
        default:
        case "default":
          colorClass =
            "bg-light hover:bg-light/90 active:bg-light/90 text-dark/90 hover:text-dark";
          break;
        case "outline":
          colorClass =
            "border-light text-light hover:bg-light hover:text-dark active:bg-light active:text-white";
          break;
      }
      break;
  }

  let sizeClass = null;
  switch (size) {
    default:
    case "m":
      sizeClass = "text-base px-8 py-3.5";
      break;
    case "l":
      sizeClass = "text-xl px-4 py-4";
      break;
    case "s":
      sizeClass = "text-base px-3 py-2";
      break;
  }

  return (
    <button
      className={classNames(
        "flex items-center focus-visible:outline-none font-normal text-center rounded-md transition duration-300",
        sizeClass,
        colorClass,
        className,
        {
          "flex w-full justify-center": block,
          "inline-flex w-auto": !block,
          border: variant === "outline",
        }
      )}
      type={type}
      {...buttonProps}
    >
      {icon && <span className="mr-3 text-2xl">{icon}</span>}
      {children}
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "success",
    "info",
    "warning",
    "danger",
    "dark",
    "link",
    "light",
  ]),
  size: PropTypes.string,
  className: PropTypes.string,
  block: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "outline"]),
  icon: PropTypes.element,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  type: "button",
  size: "m",
  color: "primary",
  variant: "default",
  className: "",
  block: false,
  disabled: false,
};
